// Configuration centralisée des statistiques cybersécurité
export const CYBERSECURITY_STATS = {
  dailyAttacks: {
    number: '600M',
    text: 'Cyberattaques par jour en 2024',
    source: 'Microsoft Digital Defense Report 2024',
    url:
      'https://www.microsoft.com/fr-fr/security/security-insider/intelligence-reports/microsoft-digital-defense-report-2024'
  },
  globalCost: {
    number: '$10.5T',
    text: 'Coût mondial de la cybercriminalité en 2025',
    source: 'Cybersecurity Ventures',
    url:
      'https://cybersecurityventures.com/cybercrime-damages-6-trillion-by-2021/'
  },
  unfilledPositions: {
    number: '3.5M',
    text: 'Postes cybersécurité non pourvus',
    source: 'ISC²',
    url: 'https://www.isc2.org/Research/Workforce-Study'
  },
  humanError: {
    number: '95%',
    text: 'Des incidents dus à des erreurs humaines',
    source: 'IBM Security',
    url: 'https://www.ibm.com/reports/data-breach'
  },
  detectionTime: {
    number: '287 jours',
    text: 'Temps moyen pour détecter un incident',
    source: 'IBM Cost of Data Breach 2025',
    url: 'https://www.ibm.com/reports/data-breach'
  },
  breachCost: {
    number: '$4.88M',
    text: "Coût moyen d'un incident de sécurité",
    source: 'IBM Security',
    url: 'https://www.ibm.com/reports/data-breach'
  }
};

// Fonction utilitaire pour formater les statistiques
export const formatStatSummary = () => {
  return `${CYBERSECURITY_STATS.dailyAttacks.number} d'attaques/jour, ${CYBERSECURITY_STATS.globalCost.number} de coût`;
};
